import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { saveUserHomePageSettings } from 'api/appSettings.service';
import { HomePageWidgets_queryKey } from './constants';
import type { HomePageWidgetConfig } from 'pages/HomePage/constants';

/**
 * Saves custom layout for the current admin
 * PUT /admins/me/settings/home-page
 */
export const useSaveHomePageWidgetsQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation<
    void,
    AxiosError,
    HomePageWidgetConfig
  >({
    mutationFn: saveUserHomePageSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [HomePageWidgets_queryKey] });
      toast.success('Home Page widgets layout has been saved successfully');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
    onSettled: () => {
      // Invalidate the query to ensure we fetch the freshest data from the server
      queryClient.invalidateQueries({ queryKey: [HomePageWidgets_queryKey] });
    },
  });

  return { isLoading: isPending, mutate };
};
